import Button, { type ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import { getButtonColors } from '../../../KestrixDesignSystem.jsx';
import { baseButtonStyles, type ButtonColors } from '../buttonStyles.ts';

export type KestrixColorVariant = "primary" | "default" | "danger" | "warning" | "subtle";

type KestrixVariantButtonProps = ButtonProps & {
  kestrixVariant: KestrixColorVariant;
};

export const KestrixVariantButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "kestrixVariant",
})<KestrixVariantButtonProps>(({ size = "medium", kestrixVariant }) => {
  const buttonColors = getButtonColors(kestrixVariant) as ButtonColors;
  return baseButtonStyles(buttonColors, size);
});
